// cSpell: disable
import React, { useState } from 'react';
import axios from 'axios';
import Useletter from '../Useletter';
import Foter from '../Foter';
function Sign() {
  const [orderNumber, setOrderNumber] = useState('');
  const [orderDetails, setOrderDetails] = useState(null);
  const [error, setError] = useState('');
  const handleTrackOrder = async () => {
  if (!orderNumber.trim()) {
    alert('Please enter your order number.');
    return;
  }

  console.log('Tracking Order Number:', orderNumber); // Log the order number

  try {
    const response = await axios.get(`http://localhost:4000/api/order/${orderNumber}`);
    setOrderDetails(response.data);
    setError('');
  } catch (err) {
    console.error('Error fetching order:', err.response?.data || err.message);
    setError(err.response?.data?.message || 'An error occurred while fetching the order.');
    setOrderDetails(null);
  }
};  return (
    <div>
      <div className="point" style={{ textAlign: 'left' }}>
        <p>Please enter the required information below to track your order status.</p>
      </div>
      <div className="b" style={{ textAlign: 'left' }}>
        <b>Order Number</b>
      </div>
      <div style={{ textAlign: 'left' }}>
        <input
          style={{ padding: '10px', width: '350px' }}
          type="text"
          placeholder="Enter your order number"
          value={orderNumber}
          onChange={(e) => setOrderNumber(e.target.value)}
        />
      </div>
      <br />
      <div style={{ textAlign: 'left' }}>
        <button className="bt" onClick={handleTrackOrder}>
          TRACK ORDER
        </button>
      </div>
      <br />
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {orderDetails && (
        <div style={{ textAlign: 'left' }}>
          <h4>Order Details</h4>
          <p><b>Order Number:</b> {orderDetails.orderNumber}</p>
          <p><b>Customer Name:</b> {orderDetails.customerName}</p>
          <p><b>Email:</b> {orderDetails.email}</p>
          <p><b>Status:</b> {orderDetails.status}</p>
          <h5>Items:</h5>
          <ul>
            {orderDetails.items.map((item, index) => (
              <li key={index}>
                {item.productName} - Quantity: {item.quantity}
              </li>
            ))}
          </ul>
        </div>
      )}
      <Useletter />
      <Foter />
    </div>
  );
}

export default Sign;